import { map } from 'rxjs/operators';
import { IEpic, isTypeOf } from '@cbridge-utils/redux-observable';
import { DetailsSidebarAction } from '@cbridge-packages/details-sidebar';
import { ServerAction } from '@cbridge-packages/server';

export const closeServerSidebarEpic: IEpic = (action$) => action$.pipe(
  isTypeOf(
    ServerAction.create.done,
  ),
  map(() => {
    return DetailsSidebarAction.close();
  }),
);
